module.exports = __webpack_public_path__ + "static/media/efs_minsk_map_minorRoads.90a0d8e4.jpg";